import _ from 'underscore';

export const getInlineDownloadUtils = () => {
  const processReportRuleForHotelCenterBIDimensionRow = ReportRule => _.defaults({
    SaveReport: true,
    Selection: _.defaults({
      '@odata.type': '#Model.DimensionReportSelection',
      Type: 'VerticalPerformance',
    }, ReportRule.Selection),
  }, ReportRule);

  const processReportRuleForHotelCenterBookingRow = ReportRule => _.defaults({
    SaveReport: true,
    Selection: _.defaults({
      '@odata.type': '#Model.DimensionReportSelection',
      Type: 'VerticalBookingDetails',
    }, ReportRule.Selection),
  }, ReportRule);

  return {
    inlineDownloadUtils: {
      processReportRuleForHotelCenterBIDimensionRow,
      processReportRuleForHotelCenterBookingRow,
    },
  };
};

